<template>
  <ExperienceList :userId="userData.id">
    <template v-slot:header>
      <SectionThreeItemsHeader class="mb-6 mt-2">
        <template v-slot:item-center>
          <h2>Experience</h2>
        </template>
        <template v-slot:item-right>
          <EditExperienceAction v-if="isEditable" />
        </template>
      </SectionThreeItemsHeader>
    </template>
  </ExperienceList>
</template>

<script>
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import EditExperienceAction from "@/views/settings/components/actions/EditExperienceAction";
import ExperienceList from "@/components/workers/experience/ExperienceList";

export default {
  components: {
    EditExperienceAction,
    SectionThreeItemsHeader,
    ExperienceList
  },
  props: {
    userData: {
      type: Object,
      required: true
    },
    isEditable: Boolean
  }
};
</script>

<style lang="scss"></style>
